import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, Button, CircularProgress, Divider } from '@mui/material'
import { TextField } from '@front/squirtle'

import Validation from '../Validation'

const CircularProgressWithLabel = ({ current, total, label, ...props }) =>
  <Box p={1} display='flex' flexDirection='column' alignItems='center' {...props}>
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="static" size={180} value={(current * 100 / total)} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box>
          <Typography variant='h6' textAlign='center' color='primary.main'>  {`${current}/${total}`}</Typography>
          <Typography variant='h6' textAlign='center' color='primary.main'>{label} </Typography>
        </Box>
      </Box>
    </Box>
  </Box>

const SearchForm = ({
  list_client_id,
  import_total,
  total,
  created,
  isComplete,
  onCancelList,
  onClickReturn,
  task
}) =>
  <Box>
    <Button onClick={onClickReturn} variant={'outlined'} sx={{ textTransform: 'none' }}>
      <Typography >{I18n.t('action.back')}</Typography>
    </Button>
    <Box p={3} boxShadow={2} m={3} >
      <Divider>
        <Typography variant='h4' textAlign='center' color='primary.main' mx={2}>{I18n.t('list.title', { list_client_id })}</Typography>
      </Divider>
      <Box display='flex' direction='row' justifyContent='center' alignItems='center' my={3}>
        <CircularProgressWithLabel
          label={I18n.t('order.import.alter')}
          current={created}
          total={_.max([import_total, total])}
          mx={2}
        />
      </Box>
      <Divider>
        <Box display='flex' justifyContent='center' alignItems='center' mx={2}>
          <Button
            onClick={onCancelList}
            color='error'
            variant='contained'
            disabled={!isComplete}
          >
            {I18n.t('action.delete')}
          </Button>
        </Box>
      </Divider>
    </Box>
    <Box><Validation task={task} /></Box>

    <Box visibility='hidden'><TextField name='submitOnMount' /></Box>
  </Box>



export default React.memo(SearchForm)
